
<div class="modalAdmin">
    <div class="contenidoModal">
      <div class="header">
        <img src="/assets/icon-summary/check-approved.svg" alt="">
        <img src="/assets/icono/equis.svg" alt="" class="cerrar mr-2" (click)="closeModal()"/>
      </div>
      <div class="content-body">
        <div class="title">
          <h2 class="copec-bold-20">Solicitud Aceptada</h2>
          <p class="copec-lg-16" style="line-height: 26px; color:#6F798F; margin-bottom: 0;">¿Esta Seguro que desea Aprobar?</p>
        </div>
        <div class="comment-section">
            <p class="texttask">Agregar comentario (opcional)</p>
            <textarea name="" id="" class="comment" [(ngModel)]="comentario" placeholder="Escribe tu comentario aquí..."></textarea>
        </div>
  </div>
      <div class="buttons">
        <button class="cancelar" (click)="closeModal()">Cancelar</button>
        <button class ="cambiarme" (click)="savedRequest()">Aprobar y guardar</button>
      </div>
 </div>
</div>
